<template>
  <div v-if="currentStatus !== 'answered'">
    <template v-if="list">
      <v-list-tile @click.capture.stop="updateQuestionStatus('validated')">
        <v-list-tile-action>
          <v-icon color="primary">thumb_up</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          {{ $t('message.metadata.question.validate') }}
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click.capture.stop="updateQuestionStatus('pending')">
        <v-list-tile-action>
          <v-icon color="primary">access_time</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          {{ $t('message.metadata.question.pending') }}
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click.capture.stop="updateQuestionStatus('banned')">
        <v-list-tile-action>
          <v-icon color="primary">thumb_down</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          {{ $t('message.metadata.question.ban') }}
        </v-list-tile-content>
      </v-list-tile>
    </template>

    <v-layout shrink row v-else>

      <v-tooltip bottom>
        <v-btn
            slot="activator"
            :input-value="currentStatus === 'validated'"
            :loading="loading.validated"
            :disabled="loading.banned || loading.pending"
            class="ma-0"
            flat
            icon
            @click.stop.prevent="updateQuestionStatus('validated')">
          <v-icon small>thumb_up</v-icon>
        </v-btn>
        <span v-html="$t('message.metadata.question.validate')"></span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
            slot="activator"
            :input-value="currentStatus === 'pending'"
            :loading="loading.pending"
            :disabled="loading.banned || loading.validated"
            class="ma-0"
            flat
            icon
            @click.stop.prevent="updateQuestionStatus('pending')">
          <v-icon small>access_time</v-icon>
        </v-btn>
        <span v-html="$t('message.metadata.question.pending')"></span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
            slot="activator"
            :input-value="currentStatus === 'banned'"
            :loading="loading.banned"
            :disabled="loading.pending || loading.validated"
            class="ma-0"
            flat
            icon
            @click.stop.prevent="updateQuestionStatus('banned')">
          <v-icon small>thumb_down</v-icon>
        </v-btn>
        <span v-html="$t('message.metadata.question.ban')"></span>
      </v-tooltip>
    </v-layout>
  </div>
</template>

<script>
import apiFactory from '@/modules/entity/api';
import { mapGetters } from 'vuex';
import { invert } from 'lodash';

export default {
  name: 'nx-list-action-question-moderation',
  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    list: {
      type: Boolean,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      loading: {
        validated: false,
        pending: false,
        banned: false,
      },
      currentStatus: null,
    };
  },
  computed: {
    ...mapGetters(['context']),
  },
  methods: {
    statusStrToInt(statusStr, flip) {
      const map = {
        pending: 1,
        validated: 2,
        banned: 3,
      };
      if (flip) {
        return invert(map)[statusStr];
      }
      return map[statusStr];
    },
    async updateQuestionStatus(status) {
      this.loading[status] = true;
      const previousStatus = this.currentStatus;
      this.currentStatus = null;
      try {
        const digitalInterviewQuestionsAPI = apiFactory('digitalInterviewQuestion');
        const result = await digitalInterviewQuestionsAPI.update(
          this.id, null,
          { status: this.statusStrToInt(status), context: this.context },
        );
        this.currentStatus = this.statusStrToInt(result.status, true);
        this.$emit('updateItem');
      } catch (error) {
        this.currentStatus = previousStatus;
        console.error(error);
        this.toast.notify('message.error.serverError');
      } finally {
        this.loading[status] = false;
      }
    },
  },
  mounted() {
    this.currentStatus = this.status;
  },
};
</script>
